import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { isNullOrEmpty } from '@awp/core/utils';

@Injectable()
export class GoogleTagManagerLoaderService {

  constructor(@Inject(DOCUMENT) private document: Document) { }

  load(tag: string): void {
    if (isNullOrEmpty(tag)) {
      console.error('Google Tag is not defined');
      return;
    }

    const script = this.document.createElement('script');
    script.innerHTML = this.getScriptTag(tag);
    this.document.body.appendChild(script);
  }

  private getScriptTag(tag: string): string {
    return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${tag}');`;
  }
}